<template>
  <div id="deactiveModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header deactiveModal-bgcolor">
          <button type="button" class="close" data-toggle="modal" data-target="#deactiveModal">&times;</button>
        </div>
        <div class="modal-body desc-text">
          <div class="modal-title">
            <div class="title-text">Are you sure you want to deactivate the User(s)?</div>
            <div class="bold-text ft-18 break-word" v-for="(user,index) in users" :key="index"><span>{{user.user_name_and_email.email}}</span></div>
          </div>
          <p class="pt-20">By deactivating this user(s), the user(s) will not able to access the portal for the below account.</p>
          <p class="bold-text">{{account.account_name}}</p>
        </div>
        <div class="modal-footer deactiveModal-bgcolor">
          <div class="col-sm-6 col-xs-12 mr-tp-10">
            <button
              class="btn btn-block emergo-white-button"
              href="#ConfirmationModal"
              @click="deactivateUser"
            >Yes, please deactivate</button>
          </div>
          <div class="col-sm-6 col-xs-12 mr-tp-10">
            <button
              class="btn btn-block emergo-blue-button"
              data-toggle="modal"
              data-target="#deactiveModal"
            >No, keep User active</button>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import { deactivateUser } from '../../apis/activityTracker';

export default {
  props: ['users', 'deactivated', 'account'],
  data() {
    return {
      loaderStatus: false,
    };
  },
  components: {
    Loader,
  },
  methods: {
    async deactivateUser() {
      this.loaderStatus = true;
      const data = [];
      this.users.forEach((user) => {
        data.push({
          user_id: user.user_id,
          account_id: this.account.account_id,
        });
      });
      const respData = await deactivateUser(data);
      this.loaderStatus = false;
      if (respData.status_code === 200) {
        this.$emit('deactivated');
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'User deactivated successfully!',
          group: 'custom-notification',
        });
      } else {
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'could not deactivate user!',
          group: 'custom-notification',
        });
      }
      $('#deactiveModal').modal('hide');
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.btn{
  padding:6px 20px;
}
.pt-20{
  padding-top: 20px;
}
.mb-15{
  margin-bottom: 15px;
}
.pb-20{
  padding-bottom:20px;
}
.mr-tp-10{
  margin-top: 10px;
}
.modal-header .close {
  background: none;
  opacity: 0.5;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
.modal-header .back{
  color: #0b3c61;
}
.modal-header.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-content.first-modal-content {
  border-radius: 12px;
}
.title-text {
  font-size: 18px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  padding-bottom: 15px;
  font-weight: normal;
}
.bold-text {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  text-align: center;
  color: #0b3c61;
}
.ft-18{
  font-size: 18px;
}
.desc-text {
  padding: 0px 55px 5px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #828282;
  min-height: 150px;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 32px;
}
.modal-header.scnd-deactiveModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 0px;
}
div#deactiveModal {
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 0;
}
::v-deep .el-select{
  width:100%;
}
.field_label {
  padding: 10px 0px 10px 15px;
}
.account-details{
  font-size: 16px;
  font-weight: normal;
  color:rgba(0, 0, 0, 0.7);
}
@media screen and (max-width: 767px) {
  .desc-text{
    padding: 0px 25px 5px;
  }
  .break-word{
    word-break: break-word;
  }
}
</style>
